/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	jQuery(function ($) {
	
	  'use strict';
	
	  $('.btn-group .dropdown-menu').on('click', function (e) {
	    e.stopPropagation();
	  });
	
	  // counter
	  $('.count-result').countTo();
	  $('.fact-box-count').countTo();
	  // progres bar
	
	  $('.progress-bar.one').on('inview', function (event, isInView) {
	    if (isInView) {
	      $(this).css({ 'width': '70%' });
	    } else {
	      $(this).css({ 'width': '0%' });
	    }
	  });
	
	  $('.progress-bar.two').on('inview', function (event, isInView) {
	    if (isInView) {
	      $(this).css({ 'width': '95%' });
	    } else {
	      $(this).css({ 'width': '0%' });
	    }
	  });
	
	  $('.progress-bar.three').on('inview', function (event, isInView) {
	    if (isInView) {
	      $(this).css({ 'width': '50%' });
	    } else {
	      $(this).css({ 'width': '0%' });
	    }
	  });
	
	  // Sticky header
	  $("#sticker").sticky({ topSpacing: 0 });
	  $("#elements-menu").sticky({ topSpacing: 120 });
	
	  $(window).scroll(function () {
	    var scroll = $(window).scrollTop();
	    if (scroll >= 20) {
	      $(".home-two-nav").addClass("nav-two-bg");
	    }
	    if (scroll === 0) {
	      $(".home-two-nav").removeClass("nav-two-bg");
	    }
	  });
	
	  $(window).scroll(function () {
	    var scroll = $(window).scrollTop();
	    if (scroll >= 20) {
	      $(".single-post-nav").addClass("nav-two-bg");
	    }
	    if (scroll === 0) {
	      $(".single-post-nav").removeClass("nav-two-bg");
	    }
	  });
	
	  // Elements page sidevar menu sticky
	  $(window).scroll(function () {
	    if ($(this).scrollTop() > $(document).height() - $(".rq-footer").height() - $(window).height()) {
	      $("#elements-menu").css('visibility', 'hidden');
	    } else {
	      $("#elements-menu").css('visibility', 'visible');
	    }
	  });
	
	  // Footer toggle widget
	  $(".toggle-widget").on('click', function () {
	    $(".footer-widget").slideToggle(300);
	    $(this).toggleClass('active');
	  });
	
	  // Range sdlier jquery ui
	  $("#slider-range").slider({
	    range: true,
	    min: 0,
	    max: 500,
	    values: [75, 300],
	    slide: function slide(event, ui) {
	      $("#amount").val("$" + ui.values[0] + " - $" + ui.values[1]);
	    }
	  });
	  $("#amount").val("$" + $("#slider-range").slider("values", 0) + " - $" + $("#slider-range").slider("values", 1));
	
	  // Nice scroll plugin customizatin
	  $(".child-tab-wrapper .nav-tabs").niceScroll({
	    scrollspeed: 10,
	    mousescrollstep: 100,
	    autohidemode: true,
	    cursorcolor: "#0a252e",
	    background: "#efeeee",
	    cursorborderradius: 0,
	    cursorborder: 0
	  });
	  $(".rq-listing-choose.rq-listing-list-two .listing-single").niceScroll({});
	
	  // Custom select box
	  $('.rq-home-search select').select2();
	  $('.rq-cart-options-content select').select2();
	
	  // faq accordion
	  $('.faq-single .hidden-content').hide();
	  $('.faq-single').on('click', 'a.faq-title', function (e) {
	    e.preventDefault();
	    var item = $(this);
	    var row = item.next('p.hidden-content');
	    var contentHide = $('p.hidden-content');
	    var titleHide = $('a.faq-title');
	
	    if (item.hasClass('active') !== false) {
	      contentHide.slideUp();
	      item.removeClass('active');
	    } else {
	      titleHide.removeClass('active');
	      item.toggleClass('active');
	      contentHide.slideUp();
	      row.slideToggle();
	    }
	  });
	
	  // owl carousel
	  $('.owl-loop').owlCarousel({
	    center: true,
	    items: 1,
	    loop: true,
	    nav: true,
	    navText: ['&#xf3d2;', '&#xf3d3;'],
	    margin: 20,
	    responsive: {
	      600: {
	        items: 1
	      },
	      1000: {
	        items: 3
	      },
	      1400: {
	        items: 5
	      }
	    }
	  });
	
	  $('.details-slider').owlCarousel({
	    center: true,
	    items: 1,
	    loop: $('.item').length > 1 ? true : false,
	    nav: true,
	    autoHeight: false,
	    lazyLoad: true,
	    navText: ['&#xf3d2', '&#xf3d3;']
	  });
	
	  $(window).on('resize', function () {
	    var $owlCar = jQuery('.details-slider');
	
	    $owlCar.trigger('destroy.owl.carousel');
	    $owlCar.html($owlCar.find('.owl-stage-outer').html()).removeClass('owl-loaded');
	    $owlCar.owlCarousel({
	      center: true,
	      items: 1,
	      loop: $('.item').length > 1 ? true : false,
	      nav: true,
	      autoHeight: false,
	      lazyLoad: true,
	      navText: ['&#xf3d2', '&#xf3d3;']
	    });
	  });
	
	  $('.details-slider-data').owlCarousel({
	    center: true,
	    items: 1,
	    loop: true
	  });
	
	  $('.testimonial-wrapper').owlCarousel({
	    center: true,
	    items: 1,
	    loop: true,
	    autoplay: true,
	    nav: false,
	    lazyLoad: true,
	    navText: ['&#xf3d2;', '&#xf3d3;'],
	    margin: 20
	  });
	
	  // responsive video
	  $('.post-content').fitVids();
	});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// scripts.js